"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtersMiddleware = void 0;
const filters_1 = require("../../actions/filters");
const filter_dto_1 = require("../../utils/filter-dto");
const actions_1 = require("../../actions");
const filtersMiddleware = () => (next) => (action) => {
    switch (action.type) {
        case filters_1.HANDLE_FILTER_RESPONSE:
            const response = action.payload;
            const { filterOptions = {}, totalCount: count = 0, entryUrl: url = '', items: filterItems = [], vehicleBasic: vehiclesArray = [], groups, } = response;
            const activeFilters = new Set();
            const activePresets = new Set();
            filterItems.forEach((filter) => {
                const filterDTO = new filter_dto_1.default(filter);
                if (filterDTO.isActive() && !filterDTO.isPreset()) {
                    activeFilters.add(filterDTO.toString());
                }
                if (filterDTO.isPreset()) {
                    activePresets.add(filterDTO.toString());
                }
            });
            const filter = [...activeFilters];
            const preset = [...activePresets];
            const hasGeoFilter = !!filter.filter((item) => item.includes('geo:')).length;
            const hasGeoPreset = !!preset.filter((item) => item.includes('geo:')).length;
            const actionSequence = [
                actions_1.ACTIONS.TOTAL_COUNT.setTotalCount({ count }),
                actions_1.ACTIONS.UI.setShowDistance({ state: hasGeoFilter || hasGeoPreset }),
                actions_1.ACTIONS.FILTER_OPTIONS.setFilterOptions({ filterOptions }),
                actions_1.ACTIONS.FILTERS.setFilters({ filterItems }),
                actions_1.ACTIONS.FILTER_PARAMS.setFilterParams({
                    filterParams: {
                        filter,
                        preset,
                    },
                }),
                actions_1.ACTIONS.ENTRY_URL.setEntryUrl({ url }),
                actions_1.ACTIONS.FILTERS.setGroups({ filterGroups: groups }),
            ];
            if (response.header && !!response.header.sort) {
                actionSequence.push(actions_1.ACTIONS.SORTING.setSorting({ sorting: { results: response.header.sort } }));
            }
            const vehicleIds = (vehiclesArray || []).map((vehicle) => vehicle.id);
            const vehiclesActions = [];
            if (vehiclesArray.length) {
                vehiclesActions.push(actions_1.ACTIONS.VEHICLES.setVehicles({ vehicles: vehiclesArray }));
                vehiclesActions.push(actions_1.ACTIONS.RESULT_VEHICLEIDS.setResultVehicleIds({ vehicleIds }));
            }
            else {
                vehiclesActions.push(actions_1.ACTIONS.RESULT_VEHICLEIDS.clearResultVehicleIds());
            }
            next([...actionSequence, ...vehiclesActions]);
            break;
        case filters_1.TRIGGER_FILTER_RESET:
            next([
                actions_1.ACTIONS.RESULT_VEHICLEIDS.clearResultVehicleIds(),
                actions_1.ACTIONS.COMPARED_VEHICLES.resetCompareVehicleIds(),
                actions_1.ACTIONS.SORTING.resetSorting(),
            ]);
            break;
        default:
            next(action);
    }
};
exports.filtersMiddleware = filtersMiddleware;
//# sourceMappingURL=filters.middleware.js.map